import { Button, Container, Grid, useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import {
  FirebaseConfigKey,
  FirebaseService,
} from '../../../services/FirebaseService'
import { SkyPaper } from '../../Core/Frames/SkyPaper'
import { TextDivider } from '../../Core/TextDivier'
import { ReactComponent as VMark } from '../../../assets/v_circle.svg'
import { ReactComponent as XMark } from '../../../assets/x_circle.svg'
import './CoveragePlanCard.scss'
import { FlatOutlinedButton } from '../../Core/Buttons/FlatOutlinedButton'
import { KPretty, CentPretty } from '../../../services/utils'
import { BlueGrayBox } from '../../Core/BlueGrayBox'
import SimpleAccordion from '../../Core/Expansion/SimpleAccordion'
import { SkyInformationPopover } from '../../Core/Popover/SkyPopover'

const classNames = require('classnames')

export const PlanPrice = ({ value, per, perMile, isMobile, isHighlighted }) => {
  let color = isHighlighted ? 'white' : 'secondaryblack'
  let color2 = isHighlighted ? 'backbuttongray' : 'blue'

  if (isMobile)
    return (
      <div>
        <span className={`text-secondary bolder ${color}`}>
          {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
        </span>
        <span
          className={`text-promotion bolder ${color}`}
          style={{ fontSize: 40 }}>
          {value.toFixed(0)}
        </span>
        <div className={`text-body ${color}`}>
          {per == 'month' ? 'Monthly' : per}
        </div>
        <div className={`text-body ${color}`}>Base Rate</div>
        <div
          style={{ fontStyle: 'oblique', textAlign: 'left' }}
          className={`text-body ${color2} margin-top-6`}>
          +{CentPretty(perMile)} Per Mile
        </div>
      </div>
    )
  else
    return (
      <div className="textcenter margin-top-small margin-bottom-small">
        <FlexView vAlignContent={'center'} hAlignContent={'center'}>
          <div>
            <div className="plan-price secondaryblack bolder">
              {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
              {value.toFixed(0)}
            </div>
            <div
              style={{ fontStyle: 'oblique', textAlign: 'left' }}
              className="text-title secondaryblack">
              +{CentPretty(perMile)} Per Mile
            </div>
          </div>
          <div
            className="text-title secondaryblack bold margin-left-3"
            style={{ fontStyle: 'oblique', textAlign: 'left' }}>
            <div>{per == 'month' ? 'Monthly' : per}</div>
            <div>Base Rate</div>
          </div>
        </FlexView>
      </div>
    )
}

export const FeatureLine = ({ feature }) => {
  let isBool = (val) => {
    return val == 'true' || val == 'false'
  }
  return (
    <>
      <FlexView
        className="space-between full-width margin-top-basic margin-bottom-basic"
        vAlignContent={'center'}>
        <FlexView vAlignContent={'center'}>
          {feature.included == 'yes' && (
            <VMark className="margin-right-small" />
          )}
          {feature.included == 'no' && <XMark className="margin-right-small" />}
          <div className="text-secondary gray">{feature.title}</div>
          {feature.tooltip && (
            <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
              <div className="text-small">{feature.tooltip}</div>
            </SkyInformationPopover>
          )}
        </FlexView>
        {feature.subtitle && !isBool(feature.subtitle) && (
          <div className="text-small gray">{feature.subtitle}</div>
        )}
      </FlexView>
      {/* {feature.breakdown && feature.breakdown.map((item, index) => 
            <FlexView key={index} className='space-between full-width margin-top-basic margin-bottom-basic' vAlignContent={'center'}>
                <div className='text-small backbuttongray'>{item.label}</div>
                {!isNaN(item.sublabel) && <div className='text-small gray'>{KPretty(item.sublabel)}</div>}
            </FlexView>)} */}
    </>
  )
}

export const CoveragePlanCard = ({ plan, onClick, isHighlighted }) => {
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  return (
    <Container maxWidth="xs">
      <SkyPaper
        className={`${isMobile && isHighlighted ? 'margin-top-large' : ''}`}>
        {isHighlighted && (
          <div
            className={`floating-label text-title textcenter white bold ${
              isMobile ? '' : ''
            }`}>
            Our Best Value
          </div>
        )}
        {isMobile && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={5}>
                {/* <BlueGrayBox className={classNames({"anti": isHighlighted})}> */}
                <BlueGrayBox>
                  <PlanPrice
                    isMobile={isMobile}
                    value={plan.fixedPrice}
                    perMile={plan.perMileCharge}
                    per={plan.period}
                  />
                </BlueGrayBox>
              </Grid>
              <Grid item xs={7}>
                <div className="text-promotion black bolder margin-bottom-small">
                  {plan.label}
                </div>
                {/* <div className='text-small bold backbuttongray'>{plan.percentage}% CHOOSE THIS</div> */}
                <div className="text-small bold backbuttongray textcenter">
                  {plan.subLabel}
                </div>
                <Button
                  onClick={onClick}
                  className="margin-top-small text-small"
                  style={{ fontSize: 12 }}
                  color="primary"
                  variant={isHighlighted ? 'contained' : 'outlined'}>
                  CHOOSE PLAN
                </Button>
              </Grid>
            </Grid>

            <SimpleAccordion
              className="margin-top-basic"
              title={
                <div className="text-body gray textcenter">More details</div>
              }
              content={
                <div>
                  {plan.coverages
                    .filter((feature) => !feature.isHidden)
                    .map((feature, index) => (
                      <FeatureLine key={index} feature={feature} />
                    ))}
                </div>
              }
            />
          </>
        )}

        {!isMobile && (
          <>
            <div className="textcenter text-promotion black bolder margin-bottom-small">
              {plan.label}
            </div>
            {/* <div className='textcenter text-small bold backbuttongray'>{plan.percentage}% CHOOSE THIS</div> */}
            <div className="text-small bold backbuttongray textcenter">
              {plan.subLabel}
            </div>

            <br />
            <PlanPrice
              value={plan.fixedPrice}
              perMile={plan.perMileCharge}
              per={plan.period}
            />
            <br />
            <FlexView hAlignContent={'center'}>
              {/* //TODO: Click is on the Paper and not here since it calls parent function twice */}
              <FlatOutlinedButton onClick={onClick} gray={!isHighlighted}>
                CHOOSE PLAN
              </FlatOutlinedButton>
            </FlexView>
            {/* <FlexView hAlignContent={'center'}>
                        <img className="plan-image" src={`https://skywatchapp-prod.s3.amazonaws.com/plans/${plan.name.toLowerCase()}.jpg`} />
                    </FlexView> */}

            <TextDivider>
              <div
                className={classNames('backbuttongray text-body bold', {
                  blue: isHighlighted,
                })}>
                COVERAGES
              </div>
            </TextDivider>
            <br />

            {plan.coverages
              .filter((feature) => !feature.isHidden)
              .map((feature, index) => (
                <FeatureLine key={index} feature={feature} />
              ))}
          </>
        )}
      </SkyPaper>
    </Container>
  )
}
